<div class="comments-container">
  @if (isLoadingResults || isRateLimitReached) {
  <div class="comments-loading-shade seccion-media">
    @if (isLoadingResults) {
    <mat-spinner></mat-spinner>
    }
    @if (isRateLimitReached) {
    <div class="comments-rate-limit-reached">
      limite superado ?
    </div>
    }
  </div>
  }

  <div class="comments-filters-container" *ngIf="!isLoadingResults">

  </div>

  <div class="comments-table-container" [hidden]="isLoadingResults">
    <mat-paginator [length]="resultsLength" [pageSize]="30" aria-label="Seleccion pagina comments"></mat-paginator>
    <table mat-table [dataSource]="data" class="comments-table" matSort matSortActive="created" matSortDisableClear
      matSortDirection="desc">
      <!-- Id Column -->
      <ng-container matColumnDef="_id">
        <th mat-header-cell *matHeaderCellDef>#</th>
        <td mat-cell *matCellDef="let row">{{row._id}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [length]="resultsLength" [pageSize]="30" aria-label="Seleccion pagina comments"></mat-paginator>

  </div>

</div>